(function ($, Promise) {

	// Constructor
	function BaseGame() {

		// Test if is NWJS
		this.isNWJS = (typeof nw != "undefined") ? true : false;

		// Save touch event to listen
		if(this.isNWJS) {
			this.touchEvent = "touchend";
		} else {
			this.touchEvent = "click";
		}
		// this.touchEvent = "touchend";

		// Hold current screen
		this.currentScreen = 0;

		// Hold current screen
		this.activateToolbarFrom = 1;

		// Modal callback holder
		this.modalCallback = false;

		// Init i18n
		this.i18n = new i18n(this);

		// Init Audio
		this.audio = new Audio(this);
		this.clickSound = "";

		// Locak go to screen
		this.lockScreen = false;

		// Init keyboard shrotcuts
		this.initKeyboardShortcuts();


		// Screensaver
		this.resetDelay = 90 * 1000;
		this.lastClick = 0;
		this.lastReset = 0;

		// Init buttons
		this.initButtons();
		this.initScreenSaver();
	}

	BaseGame.prototype.initScreenSaver = function () {

		// Timeout (screensaver) related
		this.resetTimer();
		$(document).on("click touchstart touchmove touchend", $.proxy(function (e) {
			this.resetTimer();
		}, this));

		requestInterval($.proxy(this.checkTimer, this), 1000);
	}

	BaseGame.prototype.initKeyboardShortcuts = function () {

		// Keyboard events
		$(window).bind("keydown", $.proxy(function (e) {

			if (e.keyCode == 27 && this.isNWJS) {
				// Escape
				nw.App.quit();
			} else if ((e.keyCode == 73 || e.keyCode == 67) && this.isNWJS) {
				// Key I or C
				nw.Window.get().showDevTools();
			}

		}, this));

		// When opened in nwjs disable right-click
		if (this.isNWJS) {
			$("body").css("cursor", "none").on("contextmenu", function (e) {
				return false;
			});
		}

	}

	BaseGame.prototype.initButtons = function () {


		console.log(this.touchEvent)

		// Init big buttons dynamic action
		// $(".game").on(this.touchEvent, ".help, .trigger, .button, .box-close, .language-button", $.proxy(function (e) {
		$(".help, .trigger, .button, .box-close, .language-button").on(this.touchEvent,  $.proxy(function (e) {
			var el = $(e.currentTarget);
			if (typeof el.data("action") != "undefined") {
				var action = el.data("action")
				if (typeof this[action] == "function") {
					// Action is a function
					var functionArg = (typeof el.data("action-arg") != "undefined" ? el.data("action-arg") : "");
					console.log("BaseGame: Calling function : " + action + "(" + (functionArg ? functionArg : "") + ")");
					if (functionArg) {
						this[action](functionArg);
					} else {
						this[action]();
					}
				} else {
					console.log("BaseGame: Action not found");
				}
			}

			// Play audio click
			this.audio.play(this.clickSound);

		}, this));

		// Init home action
		$("#main").on(this.touchEvent, ".restart", $.proxy(function (e) {
			console.log("calling reset()");
			this.reset();
		}, this));

		// Close modal box
		$(".modal-box-close").on(this.touchEvent, $.proxy(function (e) {
			this.hideModal();
		}, this));

		// Play audio clickon language switch
		$("#toolbar .language-switcher ").on(this.touchEvent, $.proxy(function (e) {
			this.audio.play(this.clickSound);
		}, this));

		// language selection on home screen
		// $(document).on(this.touchEvent, ".language-bar .language-button", $.proxy(function (e) {
		// this.start();
		// }, this));
	};

	BaseGame.prototype.goToScreen = function (screenId, callback) {

		// Stop on lock
		if (this.lockScreen) {
			return false;
		}

		this.lockScreen = true;

		// Show or hide toolbar
		$("#toolbar").toggleClass("active", screenId > this.activateToolbarFrom)

		//Animate in/out + callback
		if ($(".screen.current").length > 0 && $("#screen-" + screenId).length > 0) {

			// If there is a current screen and a new screen, fade out current and fade in new, then callback
			$(".screen.current").removeClass("current").animate({
				opacity: 0,
			}, "normal", $.proxy(function () {

				$("#screen-" + screenId).animate({
					opacity: 1,
				}, "normal", $.proxy(function () {
					this.currentScreen = screenId;
					this.lockScreen = false;
					$("#screen-" + screenId).addClass("current");
					if (callback) {
						callback();
					}
				}, this));

			}, this));

		} else if ($(".screen.current").length == 0 && $("#screen-" + screenId).length > 0) {

			// If there is no current screen and a new screen,fade in new, then callback
			$("#screen-" + screenId).animate({
				opacity: 1,
			}, "normal", $.proxy(function () {
				this.currentScreen = screenId;
				this.lockScreen = false;
				$("#screen-" + screenId).addClass("current");
				if (callback) {
					callback();
				}
			}, this));

		} else if (screenId == 0 || $(".screen.current").length > 0 && $("#screen-" + screenId).length == 0) {

			// If there is a current screen and no new screen, fade out current then callback
			$(".screen.current").removeClass("current").animate({
				opacity: 0,
			}, "normal", $.proxy(function () {
				this.currentScreen = screenId;
				this.lockScreen = false;
				if (callback) {
					callback();
				}
			}, this));
		}

		return true;
	}

	BaseGame.prototype.goToNextScreen = function (callback) {
		this.goToScreen(this.currentScreen + 1, callback);
	}

	BaseGame.prototype.goToPrevScreen = function (callback) {
		var screenId = ((this.currentScreen - 1) < 1) ? $(".screen").length : (this.currentScreen - 1);
		this.goToScreen(screenId, callback);
	}

	BaseGame.prototype.showModal = function (params) {

		var defaults = {
			callback: false,
			title_fr: "Title FR",
			title_en: "Title EN",
			content_fr: "Content FR",
			content_en: "Content EN",
		}
		var options = $.extend(defaults, params);

		// Add body class
		$("body").addClass("modal")

		// Save modal callback to object
		this.modalCallback = options.callback;

		// Set content from options
		$("#modal .modal-title .fr").html(options.title_fr);
		$("#modal .modal-title .en").html(options.title_en);

		// Set content from options
		$("#modal .modal-text .fr").html(options.content_fr);
		$("#modal .modal-text .en").html(options.content_en);

	}

	BaseGame.prototype.hideModal = function (params) {

		// Remove body class
		$("body").removeClass("modal")

		// Callback
		if (this.modalCallback != false) {
			this.modalCallback();
			this.modalCallback = false;
		}
	}

	BaseGame.prototype.resetTimer = function () {
		this.lastClick = millis();
	}

	BaseGame.prototype.checkTimer = function (e) {
		var noActionSince = millis() - this.lastClick;
		if (noActionSince > this.resetDelay && this.resetDelay != -1) {
			this.goToScrenSaver();
		}
	}

	BaseGame.prototype.goToScrenSaver = function () {
		// To be overriden in child games
	}

	BaseGame.prototype.shouldReset = function () {

		if (millis() - this.lastReset < 3000) {
			return false;
		}

		this.lastClick = millis();
		this.lastReset = millis();

		if (this.currentScreen == 1) {
			return false;
		}

		return true;
	}

	// Expose Toposequence
	window.BaseGame = BaseGame;

})(jQuery, Promise);